<form
  [formGroup]="targetForm"
  (ngSubmit)="onSubmit()"
  [class.disabled]="isLoading"
  id="addTargetForm"
>
  <h2 class="form-title">{{ titleName }}</h2>

  @if (isLoading) {
  <div class="loading">
    <app-loading-indicator />
  </div>
  }

  <div class="control-row" id="targetName">
    <div class="control no-margin">
      <label for="targetName">Target Name</label>
      <input
        id="targetNameInput"
        class="form-control"
        type="text"
        name="targetName"
        formControlName="targetName"
      />
    </div>
    @if (targetForm.controls.targetName.invalid &&
    targetForm.controls.targetName.touched) {
    <span class="control-error">Target Name is required.</span>
    }
  </div>

  <div class="control-row">
    <div class="control no-margin">
      <span class="float-right pointer" style="font-size: 12px; color: white" (click)="toggleShowAllPrograms()">   
        {{ showAllPrograms() ? 'Show only acquisition programs' : 'Show all programs' }}
      </span>
        <label for="selectedPrograms">Programs:</label>
      <p-multiSelect
        id="programsDropdown"
        appendTo="body"
        autoWidth="false"
        [style]="{ width: '100%' }"
        [options]="availablePrograms()"
        formControlName="PatientProgramIDs"
        placeholder="Select Programs"
        optionLabel="label"
        optionValue="value"
        [filter]="true"
        filterBy="label"
        display="chip"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="50"
        [loading]="isLoading"
        (onClick)="onProgramsDropdownClicked()"
      >
        <ng-template pTemplate="selectedProgram" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.label }}</div>
          </div>
        </ng-template>
      </p-multiSelect>
    </div>
  </div>

  <div class="control-row">
    <div class="control no-margin">
      <label for="selectedSkillArea">Skill Area:</label>
      <p-dropdown
        id="skillAreaDropdown"
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [options]="skillAreas"
        formControlName="SkillAreaID"
        (onChange)="onSkillAreaChange($event)"
        optionLabel="SkillAreaName"
        optionValue="ID"
        [filter]="true"
        filterBy="SkillAreaName"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="50"
        [loading]="isLoading"
        placeholder="Select a Skill Area"
        (onClick)="onSkillAreaDropdownClicked()"
      >
        <ng-template pTemplate="selectedSkillArea" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.SkillAreaName }}</div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

  <div class="control-row no-margin" id="bspGoal" *ngIf="!((this.targetForm.get('PatientProgramIDs')?.value?.length ?? 0) > 0)">
    <div class="control" id="addProgramSkillAcquisitionGoal">
      <label for="selectedSkillAcquisitionGoal">BSP Current Objective:</label>
      <p-dropdown class="ProgramSkillAcquisitionGoal-dropdown"
        autoWidth="false"
        [style]="{ width: '100%' }"
        [panelStyle]="{maxWidth: '750px'}"
        appendTo="body"
        [options]="skillAcquisitionGoals"
        formControlName="BSP_SkillAcquisitionGoalID"
        name="selectedSkillAcquisitionGoal"
        [checkmark]="true"
        optionLabel="DropdownLabel"
        optionValue="ID"
        [showClear]="true"
        placeholder="Select a BSP Current Objective"
        id="addProgramSkillAcquisitionGoalDropdown"
      >
        <ng-template let-skillAcquisitionGoalItem pTemplate="item">
          <div class="d-flex align-items-center gap-2">
            <div>
              <div class="d-block wrap-text">{{ skillAcquisitionGoalItem.DropdownLabel }}</div>
            </div>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

  @if (selectedSkillAcquisitionGoal(); as selectedObjective) {
    <div class="control">
      <label>Objective Details:</label>
      <div class="objective-details">
        @if (selectedObjective.SkillArea) {
          <div class="objective-details-label">Skill Area</div>
          <div class="objective-details-value">{{selectedObjective.SkillArea}}</div>
        }
        @if (selectedObjective.Program) {
          <div class="objective-details-label">Program</div>
          <div class="objective-details-value">{{selectedObjective.Program}}</div>
        }
        @if (selectedObjective.GoalStatus) {
          <div class="objective-details-label">Objective Status</div>
          <div class="objective-details-value">{{selectedObjective.GoalStatus}}</div>
        }
        @if (selectedObjective.Goal) {
          <div class="objective-details-label">Objective</div>
          <div class="objective-details-value">{{selectedObjective.Goal}}</div>
        }
        @if (selectedObjective.BaselineDate) {
          <div class="objective-details-label">Baseline Date</div>
          <div class="objective-details-value">{{selectedObjective.BaselineDate | date : "MM/dd/yyyy"}}</div>
        }
        @if (selectedObjective.Baseline) {
          <div class="objective-details-label">Baseline</div>
          <div class="objective-details-value">{{selectedObjective.Baseline}}</div>
        }
        @if (selectedObjective.SociallySignificantInformation) {
          <div class="objective-details-label">Socially Significant Info</div>
          <div class="objective-details-value">{{selectedObjective.SociallySignificantInformation}}</div>
        }
        @if (selectedObjective.Progress) {
          <div class="objective-details-label">Progress</div>
          <div class="objective-details-value">{{selectedObjective.Progress}}</div>
        }
        @if (selectedObjective.PreviousGoal) {
          <div class="objective-details-label">Previous Objective</div>
          <div class="objective-details-value">{{selectedObjective.PreviousGoal}}</div>
        }
      </div>
    </div>

    @if ((selectedObjective.TreatmentGoals?.length ?? 0) > 0) {
      <div class="control ">
        <label for="selectedOtherCurrentObjective">Treatment Goals that support this objective:</label>
        @for (goal of selectedObjective.TreatmentGoals; track goal) {
          <div class="ms-3 d-flex align-items-center gap-2">
            <div>
              <div class="d-block mb-2 wrap-text text-white text-14">- {{goal}}</div>
            </div>
          </div>
        }
      </div>
    }
  }

  <div class="control-row" id="playlists">
    <div class="control no-margin">
      <label for="selectedPlaylists">Playlists:</label>
      <p-multiSelect
        appendTo="body"
        autoWidth="false"
        [style]="{ width: '100%' }"
        [options]="getFilteredPlaylists()"
        formControlName="PatientPlaylistIDs"
        placeholder="Select Playlists"
        optionLabel="PlaylistName"
        optionValue="ID"
        [filter]="true"
        filterBy="PlaylistName"
        display="chip"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="50"
        [loading]="isLoading"
      >
        <ng-template pTemplate="selectedPlaylist" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.PlaylistName }}</div>
          </div>
        </ng-template>
      </p-multiSelect>
    </div>
  </div>

  <div class="control-row" id="discriminativeStimulus">
    <div class="control no-margin">
      <label for="discriminativeStimulus">SD (Discriminative Stimulus)</label>
      <input
        class="form-control"
        type="text"
        id="discriminativeStimulus"
        formControlName="discriminativeStimulus"
      />
    </div>
  </div>

  <div class="control-row">
    <div class="control no-margin">
      <label for="targetType">Target Type:</label>
      <p-dropdown
        id="targetTypeDropdown"
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [options]="targetTypes"
        formControlName="targetType"
        optionValue="value"
        optionLabel="text"
        optionDisabled="disabled"
        [loading]="isLoading"
        (onClick)="onTargetTypeDropdownClicked()"
      >
      </p-dropdown>
      @if(targetForm.controls.targetType.invalid &&
      targetForm.controls.targetType.touched) {
      <span class="control-error">Target Type is required.</span>
      }
    </div>
  </div>

  @if (usesPromptSchedule()) {
  <div class="control-row">
    <div class="control no-margin">
      <label for="selectedPromptSchedule">Prompt Schedule:</label>
      <p-dropdown
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [options]="promptSchedules"
        formControlName="PromptScheduleID"
        optionLabel="PromptScheduleName"
        optionValue="ID"
        [filter]="true"
        filterBy="PromptScheduleName"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="50"
        [loading]="isLoading"
        placeholder="Select a Prompt Schedule"
      >
        <ng-template pTemplate="selectedPromptSchedule" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.PromptScheduleName }}</div>
          </div>
        </ng-template>
      </p-dropdown>
      @if (targetForm.controls.PromptScheduleID.invalid &&
      targetForm.controls.PromptScheduleID.touched) {
      <span class="control-error">Prompt Schedule is required.</span>
      }
    </div>
  </div>

  } @if (usesCustomPromptCodes()) {
  <div class="control-row">
    <div class="control no-margin">
      <label for="promptCodes">Custom Prompt Codes:</label>
      <p-multiSelect
        appendTo="body"
        autoWidth="false"
        [style]="{ width: '100%' }"
        [options]="promptCodes"
        formControlName="CustomPromptCodeIDs"
        placeholder="Select Custom Prompt Codes"
        optionLabel="Text"
        optionValue="ID"
        display="chip"
        [filter]="true"
        filterBy="Text"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="50"
        [loading]="isLoading"
      >
        <ng-template pTemplate="selectedPromptCode" let-selectedOption>
          <div class="flex align-items-center gap-2">
            <div>{{ selectedOption.Text }}</div>
          </div>
        </ng-template>
      </p-multiSelect>
      @if (isTaskAnalysis()) {
      <small class="text-muted">
        These prompts apply to this Task Analysis target's subtargets when the subtarget does not have custom prompt codes.
      </small>
      }
    </div>
  </div>

  } @if(requiresSubTargets()) {
  <div class="control-row">
    <div class="control no-margin">

      <!-- New section for creating custom subtargets -->
      <div class="mt-3">
        <div class="d-flex flex-column align-items-start mb-2">
          <label class="mb-0">Create New Sub Targets:</label>
          <button type="button" class="btn btn-success btn-sm" (click)="addNewSubTarget()">
            <i class="pi pi-plus"></i> Add New Sub Target
          </button>
        </div>
        
        @if (newSubTargets.length > 0) {
          <div class="border rounded p-3 bg-light">
            @for (newSubTarget of newSubTargets; track i; let i = $index) {
              <div class="d-flex align-items-center gap-3 mb-2 p-2 border rounded bg-white">
                <div class="flex-grow-1">
                  <input 
                    type="text" 
                    class="form-control form-control-sm" 
                    [(ngModel)]="newSubTargets[i].TargetName"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Enter target name"
                  />
                </div>
                <div class="d-flex flex-column align-items-center">
                  <span class="small mb-1">Force Open: 
                  <p-checkbox
                    [binary]="true"
                    [(ngModel)]="newSubTargets[i].ForceOpen"
                    [ngModelOptions]="{standalone: true}"
                  />
                  </span>
                </div>
                <button 
                  type="button" 
                  class="btn btn-danger btn-sm"
                  (click)="removeNewSubTarget(i)"
                  title="Remove this sub target"
                >
                  <i class="pi pi-trash"></i>
                </button>
              </div>
            }
          </div>
        }
      </div>

      <label for="subTargets">Select Existing Sub Targets:</label>
      <button type="button" class="btn btn-primary mb-2" (click)="onAddSubTarget()">{{showingAvailableTargets ? 'Hide' : 'Show'}} available targets to add</button>
      <p-pickList *ngIf="!isLoading && availableTargets && selectedSubTargets"
      [source]="availableTargets"
      [target]="selectedSubTargets"
      dataKey="ID" 
      [dragdrop]="true"
      [sourceStyle]="{ height: '100%' }" 
      [targetStyle]="{ height: '100%' }" 
      [style]="{ height: '350px' }" 
      [styleClass]="showingAvailableTargets ? 'subtarget-picklist show-available-targets' : 'subtarget-picklist hide-available-targets'"
      sourceHeader="Available Targets (drag to other side)" 
      targetHeader="Selected SubTargets (drag to order)" 
      filterBy="TargetName" 
      sourceFilterPlaceholder="Filter by Target Name" 
      showTargetFilter="false"
      showSourceControls="false"
      showTargetControls="false"
      >
      <ng-template let-subTargetItem pTemplate="item">
        <div class="d-flex align-items-center gap-2">
          <div class="force-open-container"> 
            <div class="picklist-label">Force Open</div>
            <p-checkbox
            id="{{subTargetItem.ID}}"
            [binary]="true"
            [(ngModel)]="subTargetItem.ForceOpen"
            [ngModelOptions]="{standalone: true}"
          />
        </div>
        <div>
          
          <div class="picklist-label">Target Name</div>
          <div class="d-block">{{ subTargetItem.TargetName }}</div>
        
        </div>

        </div>

        </ng-template>
      </p-pickList>


      @if (targetForm.controls.SubTargetIDs.invalid &&
      targetForm.controls.SubTargetIDs.touched) {
      <span class="control-error">Sub Targets are required.</span>
      }
    </div>
  </div>
  } @if (isTaskAnalysis()) {
    
  <div class="control-row">
    <div class="control mt-2">
      <p-selectButton
          [options]="[
            { label: 'Keep sub targets closed until previous one is mastered (you can force open some of them above)', value: false },
            { label: 'Leave all sub targets open', value: true }
          ]"
          [formControl]="targetForm.controls.OpenSubTargets"
          autoWidth="false"
          [style]="{ width: '100%', display: 'flex' }"
          size="large"
          styleClass="w-full"
          allowEmpty="false"
        >
        </p-selectButton>
    </div>
  </div>
  <div class="control-row">
    <div class="control no-margin">
      <label for="IsBackward">Is Backwards</label>
      <p-checkbox
        formControlName="IsBackward"
        [binary]="true"
        inputId="IsBackward"
      />
    </div>
  </div>

  }

  @if (!isCurrency()) {
  <div class="control-row" id="desiredTrials">
    <div class="control no-margin">
      <label for="desiredTrials">Desired Trials</label>
      <p-inputNumber
        class="w-100"
        [showButtons]="true"
        inputId="desiredTrials"
        formControlName="desiredTrials"
      />
      @if(targetForm.controls.desiredTrials.invalid &&
      targetForm.controls.desiredTrials.touched) {
      <span class="control-error"
        >Desired Trials must be between 0 and 100.</span
      >
      }
    </div>
  </div>
  }

  @if (isFluencyRate()) {
  <div class="control-row">
    <div class="control no-margin">
      <label for="FluencyRateTimerMode">Fluency Timer Mode</label>
      <p-selectButton
        [options]="fluencyRateTimerModeOptions"
        [formControl]="targetForm.controls.FluencyRateTimerMode"
        autoWidth="false"
        [style]="{ width: '100%', display: 'flex' }"
        size="large"
        styleClass="w-full full-width-select-button"
        allowEmpty="false"
      >
      </p-selectButton>
    </div>
  </div>
  }

  @if (requiresDuration()) {
  <div class="control-row">
    <div class="control no-margin">
      <label for="duration">Duration (in minutes)</label>
      <p-inputNumber
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [showButtons]="true"
        inputId="duration"
        [minFractionDigits]="1"
        [maxFractionDigits]="2"
        formControlName="duration"
      />
      @if (targetForm.controls.duration.invalid &&
      targetForm.controls.duration.touched) {
      <span class="control-error">Duration is required and must be greater than 0.</span>
      }
    </div>
  </div>
  } @if (isQuantity()) {
  <div class="control-row">
    <div class="control no-margin">
      <label for="QuantityUnit">Quantity Unit</label>
      <input
        class="form-control"
        type="text"
        id="QuantityUnit"
        formControlName="QuantityUnit"
      />
    </div>
  </div>
  }
  @if (isCurrency()) {
  <div class="control-row">
    <div class="control no-margin">
      <label for="CanBeNegative">Allow Negative Balance</label>
      <p-checkbox
        formControlName="CanBeNegative"
        [binary]="true"
        inputId="CanBeNegative"
      />
    </div>
  </div>
  }
  @if (isCurrency()) {
  <div class="control-row">
    <div class="control no-margin">
      <label for="CurrencySymbol">Currency Symbol</label>
      <input
        class="form-control"
        type="text"
        id="CurrencySymbol"
        formControlName="CurrencySymbol"
        placeholder="$"
      />
    </div>
  </div>
  @if (!shouldHideStartingBalance()) {
    <div class="control-row">
      <div class="control no-margin">
        <label for="StartingBalance">Initial Balance</label>
        <p-inputNumber
          class="w-100"
          [showButtons]="true"
          inputId="StartingBalance"
          formControlName="StartingBalance"
        ></p-inputNumber>
      </div>
    </div>
  }
  }

  @if (shouldShowAlarmOptions()) {
  <div class="control-row">
    <div class="control no-margin">
      <label for="alarm">Alarm Option</label>
      <p-dropdown
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [options]="alarmOptions"
        formControlName="AlarmOption"
      />
    </div>
    <div class="control no-margin">
      <label for="alarmSound">Alarm Sound</label>
      <p-dropdown
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [options]="alarmSounds"
        formControlName="AlarmSoundOption"
        (onChange)="playAlarmSound($event)"
      />
    </div>
  </div>
  }
  <div class="control-row">
    <div class="control no-margin">
      <label for="targetStatus">Target Status:</label>
      <p-dropdown
        autoWidth="false"
        [style]="{ width: '100%' }"
        appendTo="body"
        [options]="targetStatuses"
        formControlName="targetStatus"
        optionValue="value"
        optionLabel="text"
      >
      </p-dropdown>
    </div>
  </div>

  @if (shouldShowMasteringSection()) {
  <div class="mastering-section">
    <div class="mastering-section-header">
      <h3 class="mastering-section-title">Mastering</h3>
    </div>

    @if (!isPastMasteryPhase()) {
      @if (hasAutomaticMasteryOption()) {
      <div class="control-row">
        <div class="control no-margin">
          <label for="ShouldMasterAutomatic">Mastery Calculation:</label>
          <div class="p-fluid">
            <p-selectButton
              [options]="[
                { label: 'Manual', value: false },
                { label: 'Automatic', value: true }
              ]"
              [formControl]="targetForm.controls.ShouldMasterAutomatic"
              autoWidth="false"
              [style]="{ width: '100%', display: 'flex' }"
              size="large"
              styleClass="w-full full-width-select-button"
              allowEmpty="false"
            >
            </p-selectButton>
          </div>
        </div>
      </div>
      <p class="mastering-hint no-margin">
        {{ masteryCalculationHint }}
      </p>

      @if (selectedAutomaticMasteryOption()) {
      <div class="control-row">
        <div class="control no-margin">
          <label for="CustomMasteryCriteria">Mastery Criteria:</label>
          <div class="p-fluid">
            <p-selectButton
              [options]="[
                { label: 'Default', value: false },
                { label: 'Custom', value: true }
              ]"
              [formControl]="targetForm.controls.CustomMasteryCriteria"
              autoWidth="false"
              [style]="{ width: '100%', display: 'flex' }"
              size="large"
              styleClass="w-full full-width-select-button"
              allowEmpty="false"
            >
            </p-selectButton>
          </div>
        </div>
      </div>
      <p class="mastering-hint no-margin">
        {{ masteryCriteriaHint }}
        @if (!isCustomMasteryCriteria() && selectedPatient?.ID && (canAccessPatientMasteryCriteriaSettings || canAccessGeneralMasteryCriteriaSettings)) {
        Patient-specific or general mastery criteria can be adjusted here:
        @if (canAccessPatientMasteryCriteriaSettings) {
        <a [routerLink]="['/supervisor', selectedPatient?.ID, 'mastery-criteria']"
          >patient-specific mastery criteria</a
        >
        }
        @if (canAccessPatientMasteryCriteriaSettings && canAccessGeneralMasteryCriteriaSettings) {
        and here:
        }
        @if (canAccessGeneralMasteryCriteriaSettings) {
        <a [routerLink]="['/settings', 'mastery-criteria']"
          >general mastery criteria</a
        >.
        }
        }
      </p>
      @if (isCustomMasteryCriteria()) {
      <div class="control-row">
        <div class="control no-margin">
          <label for="responsePercentage">Response Percentage</label>
          <p-inputNumber
            [showButtons]="true"
            inputId="responsePercentage"
            formControlName="responsePercentage"
          />
          %
        </div>
      </div>
      <div class="control-row">
        <div class="control no-margin">
          <label for="consecutiveDays">Consecutive Days</label>
          <p-inputNumber
            [showButtons]="true"
            inputId="consecutiveDays"
            formControlName="consecutiveDays"
          />
        </div>
      </div>
      <div class="control-row">
        <div class="control no-margin">
          <label for="FirstTrialMustBeIndependent"
            >First Trial Must Be Independent</label
          >
          <p-checkbox
            formControlName="FirstTrialMustBeIndependent"
            [binary]="true"
            inputId="FirstTrialMustBeIndependent"
          />
        </div>
      </div>
      } @else {
      <div class="control-row">
        <div class="control no-margin">
          <label for="defaultResponsePercentage">Response Percentage</label>
          <p-inputNumber
            [showButtons]="true"
            inputId="defaultResponsePercentage"
            [ngModel]="defaultMasteryCriteria.ResponsePercentage"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="true"
          />
          %
        </div>
      </div>
      <div class="control-row">
        <div class="control no-margin">
          <label for="defaultConsecutiveDays">Consecutive Days</label>
          <p-inputNumber
            [showButtons]="true"
            inputId="defaultConsecutiveDays"
            [ngModel]="defaultMasteryCriteria.ConsecutiveDays"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="true"
          />
        </div>
      </div>
      <div class="control-row">
        <div class="control no-margin">
          <label for="defaultFirstTrialMustBeIndependent"
            >First Trial Must Be Independent</label
          >
          <p-checkbox
            inputId="defaultFirstTrialMustBeIndependent"
            [ngModel]="defaultMasteryCriteria.FirstTrialIndependent"
            [ngModelOptions]="{ standalone: true }"
            [binary]="true"
            [disabled]="true"
          />
        </div>
      </div>
      } } }
      @else {
      <p class="mastering-hint no-margin">
        Mastery Calculation is manual for this target type(Automatic Mastering is only available for DTT and Echoic targets).
      </p>
      }

      <div class="control-row">
        <div class="control no-margin">
          <label for="ShouldHandleAfterMasteryAutomatic">After Mastery:</label>
          <div class="p-fluid">
            <p-selectButton
              [options]="afterMasteryHandlingOptions"
              [formControl]="targetForm.controls.ShouldHandleAfterMasteryAutomatic"
              autoWidth="false"
              [style]="{ width: '100%', display: 'flex' }"
              size="large"
              styleClass="w-full full-width-select-button"
              allowEmpty="false"
            >
            </p-selectButton>
          </div>
        </div>
      </div>

      <p class="mastering-hint no-margin">
        {{ afterMasteryHandlingHint }}
      </p>

      @if (shouldHandleAfterMasteryAutomatically()) {
      <div class="control-row">
        <div class="control no-margin">
          <label for="ShouldMoveToMaintenanceAfterMastery">After Mastery Progression:</label>
          <div class="p-fluid">
            <p-selectButton
              [options]="masteryDestinationOptions"
              [formControl]="targetForm.controls.ShouldMoveToMaintenanceAfterMastery"
              autoWidth="false"
              [style]="{ width: '100%', display: 'flex' }"
              size="large"
              styleClass="w-full full-width-select-button"
              allowEmpty="false"
            >
            </p-selectButton>
          </div>
        </div>
      </div>

      <p class="mastering-hint no-margin">
        {{ afterMasteryHint }}
      </p>
      }
    } @else {
      <p class="mastering-hint no-margin">
        This target is already in a post-mastery status, so there are no more mastering settings to configure here.
      </p>
    }

    @if (shouldShowMaintenanceCriteriaAfterMastery()) {
      
      <div class="mastering-state-callout">
        <span class="mastering-state-callout-label">Current maintenance source</span>
        <span class="mastering-state-callout-value">
          {{ currentMaintenanceSettingsHint }}
          @if (isUsingLegacyMaintenanceCriteria) {
            <span class="legacy-maintenance-badge">Legacy</span>
          }
        </span>
      </div>
      <p class="mastering-hint no-margin">
        @if (shouldShowMaintenanceCriteriaAfterMastery() && selectedPatient?.ID && (canAccessPatientMaintenanceCriteriaSettings || canAccessGeneralMaintenanceCriteriaSettings)) {
          @if (isUsingLegacyMaintenanceCriteria) {
            {{ maintenanceCriteriaHint }}
            @if (canAccessPatientMaintenanceCriteriaSettings) {
            Update it here:
            <a [routerLink]="['/supervisor', selectedPatient?.ID, 'maintanance-criteria']"
              >patient-specific maintenance criteria</a
            >.
            }
            @if (canAccessGeneralMaintenanceCriteriaSettings) {
            You can also review the general maintenance criteria here:
            <a [routerLink]="['/settings', 'maintanance-criteria']"
              >general maintenance criteria</a
            >.
            }
          } @else {
            {{ maintenanceCriteriaHint }}
            @if (canAccessPatientMaintenanceCriteriaSettings) {
            <a [routerLink]="['/supervisor', selectedPatient?.ID, 'maintanance-criteria']"
              >patient-specific maintenance criteria</a
            >
            }
            @if (canAccessPatientMaintenanceCriteriaSettings && canAccessGeneralMaintenanceCriteriaSettings) {
            and here:
            }
            @if (canAccessGeneralMaintenanceCriteriaSettings) {
            <a [routerLink]="['/settings', 'maintanance-criteria']"
              >general maintenance criteria</a
            >.
            }
          }
        }
      </p>
    }

    @if (isInMaintenance()) {
      <div class="control-row">
        <div class="control no-margin">
          <label for="MaintenanceCriteriaID" class="maintenance-criteria-label">
            <span>Current Maintenance Criteria</span>
            @if (isUsingLegacyMaintenanceCriteria) {
              <span class="legacy-maintenance-badge">Legacy</span>
            }
          </label>
          <p-dropdown
            autoWidth="false"
            [style]="{ width: '100%' }"
            appendTo="body"
            [options]="maintenanceCriterias"
            formControlName="MaintenanceCriteriaID"
            optionLabel="text"
            optionValue="value"
          />
        </div>
      </div>
      }
  </div>
  }

  <div class="control-row" id="instructions">
    <div class="control no-margin">
      <label for="instructions">Instructions</label>
      <ckeditor
      id="instructions"
      name="instructions"
      [editor]="Editor"
      [config]="editorConfig"
      [data]="initialInstructions"
      (change)="onInstructionsChange($event)"
    ></ckeditor>
    </div>
  </div>

  <div id="favoriteAndSpecialFavorites">
    <div class="control-row">
      <div class="control no-margin">
        <label for="isFavorite">Favorite</label>
        <p-checkbox
          formControlName="isFavorite"
          [binary]="true"
          inputId="isFavorite"
        />
      </div>
    </div>

    <div class="control-row">
      <div class="control no-margin">
        <label for="isSpecialFavorite">Special Favorite</label>
        <p-checkbox
          formControlName="isSpecialFavorite"
          [binary]="true"
          inputId="isSpecialFavorite"
        />
      </div>
    </div>
  </div>
  <app-add-attachment-modal
    [showAddAttachments]="showAddAttachments"
    [view]="'targetAttachment'"
    [id]="currentTarget?.ID ?? 0"
    [targetID]="currentTarget?.ID ?? 0"
    (close)="closeAddAttachments()"
  ></app-add-attachment-modal>
  <app-attachment-view
    [doShowAttachmentView]="doShowAttachmentView"
    [attachment]="selectedAttachment"
    [canDelete]="true"  
    [view]="'targetAttachment'"
    (close)="closeAttachmentView()"
  ></app-attachment-view>
  @if(currentTarget?.ID != null && currentTarget?.ID != 0){

  <div class="row">
    <div class="col-lg-9 col-md-12 m-0 p-0 mb-2 d-flex justify-content-start align-items-end">
      <button 
        class="btn btn-secondary float-right"
        style="height: 35px; margin-top: 15px;" 
        type="button"
        (click)="toggleShowAddAttachments()" 
        [disabled]="isLoading">
        <i class="m-0 p-0 pi pi-paperclip"></i>&nbsp;&nbsp;Add Attachments
      </button>
    </div>
    <div class="col-12">
      <div class="att-list-container" style="margin-top:0px;">
        @for (att of attachmentList; track att.ID) {
          <div class="att-box" role="button" (click)="openAttachmentView(att)">
            @if(att.IsImage){
              <img class="m-2" [src]="getImageUrl(att)" style="min-width: 40px; min-height: 40px; max-width: 40px; max-height: 40px;">
            }
            @else{
              <i class="m-0 p-0 pi pi-file-o" style="font-size: 25px;"></i>
            }
          </div>
        }
      </div>
    </div>
  </div>    
}

  <div id="dates">
    <div class="control-row">
      <div class="control no-margin">
        <label for="DateOpened">Date Opened</label>
        <input
          type="date"
          [style]="{ width: '100%' }"
          appendTo="body"
          class="form-control"
          name="DateOpened"
          formControlName="DateOpened"
          autocomplete="off"
        />
      </div>

      <div class="control no-margin">
        <label for="DateBaselined">Date Probed</label>
        <input
          type="date"
          [style]="{ width: '100%' }"
          appendTo="body"
          class="form-control"
          name="DateBaselined"
          formControlName="DateBaselined"
          autocomplete="off"
        />
      </div>
    </div>

    <div class="control-row">
      <div class="control no-margin">
        <label for="DateMastered">Date Mastered</label>
        <input
          type="date"
          [style]="{ width: '100%' }"
          appendTo="body"
          class="form-control"
          name="DateMastered"
          formControlName="DateMastered"
          autocomplete="off"
        />
      </div>

      <div class="control no-margin">
        <label for="DateClosed">Date Closed</label>
        <input
          type="date"
          [style]="{ width: '100%' }"
          appendTo="body"
          class="form-control form-control"
          name="DateClosed"
          formControlName="DateClosed"
          autocomplete="off"
        />
      </div>
    </div>
  </div>

  <p class="actions" style="position: sticky; bottom: 0" id="addTargetButtons">
    <button
      type="button"
      class="switch-mode-button"
      style="margin-right: auto"
      (click)="onCancel()"
    >
      Cancel
    </button>
    @if (currentTarget?.ID) {
    <button
      type="button"
      id="archiveButton"
      [disabled]="isLoading"
      (click)="archiveButtonClicked()"
    >
      {{ currentTarget?.IsArchived ? "Unarchive" : "Archive" }}
    </button>
    }
    <button
      type="submit"
      id="saveTargetButton"
      class="side-menu-button2"
      [disabled]="isLoading"
    >
      {{ actionName }}
    </button>
  </p>
</form>
